import React from 'react';
import { Dropdown, DropdownItem, DropdownList, Input } from '@cokitchen/cokitchen-components';
import { weightMeasurement } from 'utils/constants';
import './styles.scss';
import { AddInternalProcurementType } from 'models/procurement.model';

import IngredientSelct from 'components/form-comps/ingredients-select';

const AddKitchenProcurementForm = ({
  data,
  index,
  setValue,
  removeItem,
  canWrite = true
}: {
  data: AddInternalProcurementType;
  index: number;
  setValue: (
    index: number,
    field: keyof AddInternalProcurementType,
    value: AddInternalProcurementType[keyof AddInternalProcurementType]
  ) => void;
  removeItem: (index: number) => void;
  canWrite?: boolean;
}) => {
  const unitType = data.ingredient?.unit_type || data.unit_type;
  return (
    <div className={`add__procurement pb-4 ${index > 0 ? 'pt-6' : ''} border-b border-[#EDEDEE]`}>
      <div>
        <div className='grid grid-cols-2 gap-6 mb-6 flex-wrap'>
          <div>
            <p className='font-medium mb-2'>Item name</p>
            <IngredientSelct
              value={data?.ingredient_name}
              setValue={(item) => {
                if (!canWrite) return;
                setValue(index, 'ingredient', item.ingredient);
                setValue(index, 'ingredient_id', item.id);
                setValue(index, 'ingredient_name', item.name);
                setValue(index, 'unit_type', item.unit_type);
              }}
            />
          </div>
          <div className='relative'>
            <Input
              design='bordered'
              label='Quantity'
              placeholder='00'
              value={data.quantity}
              disabled={!canWrite}
              onChange={(e) => setValue(index, 'quantity', e.target.value)}
            />

            <div className='absolute w-[50px] h-[20px] z-10 rounded-[2px] shadow bottom-[20%] right-[5%]'>
              <Dropdown
                disabled
                content={
                  <div className='h-5 p-1 text-[11px] flex justify-between items-center gap-[2px] cursor-pointer measurement_dropdown'>
                    <span className='text-[#6F7376] truncate capitalize'>
                      {
                        <span className={`text-[#6F7376] truncate ${unitType ? 'capitalize' : ''}`}>
                          {unitType ?? 'Unit(s)'}
                        </span>
                      }
                    </span>
                    {/* <ArrowDownIcon className='w-5 h-5 text-[#96999C]' /> */}
                  </div>
                }>
                <DropdownList>
                  {weightMeasurement.map((item) => (
                    <DropdownItem
                      key={item.value}
                      onClick={() => {
                        return;
                      }}>
                      {item.name}
                    </DropdownItem>
                  ))}
                </DropdownList>
              </Dropdown>
            </div>
            <span className='absolute -bottom-5 text-xs text-blue-6'>
              Available quantity: {data.ingredient?.available_quantity ?? 0}
            </span>
          </div>
        </div>
        {canWrite && index >= 1 && (
          <button
            onClick={() => removeItem(index)}
            className='text-[#E60A2B] mt-2 font-medium text-sm '>
            - Remove Item
          </button>
        )}
      </div>
    </div>
  );
};

export default AddKitchenProcurementForm;
